import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { SuppressionList, UploadSuppressionListPayload } from "../../components/types";

export type SuppressionListServiceType = {
    postSuppressionList(payload: UploadSuppressionListPayload): Promise<SuppressionList>;
    deleteSuppressionList(): Promise<void>;
    fetchSuppressionLists(): Promise<SuppressionList[]>;
};

export const suppressionListService = (fetchService: IFetchService): SuppressionListServiceType => {
    return {
        postSuppressionList: createCancelable(
            (signal: AbortSignal, payload: UploadSuppressionListPayload): Promise<SuppressionList> => {
                return fetchService.post(`/sales-api/suppression-list`, payload, {
                    cancellation: signal,
                });
            },
        ),
        deleteSuppressionList: createCancelable((signal: AbortSignal): Promise<void> => {
            return fetchService.delete(`/sales-api/suppression-list`, undefined, {
                cancellation: signal,
            });
        }),
        fetchSuppressionLists: createCancelable((signal: AbortSignal): Promise<SuppressionList[]> => {
            return fetchService.get("/sales-api/suppression-list", undefined, {
                cancellation: signal,
            });
        }),
    };
};
